import React, {useState} from 'react'
import { Navbar, Container, Nav } from 'react-bootstrap'
import NavJudul from 'components/componentsmall/nav_judul'
import Input from './input'
import NavIcons from './navIcons'
import CardsNav from './dashcomp/menu_card'
import HeadCard from './dashcomp/head_card'

export default function Navbars() {
    const [actived, setActived] = useState(false)

    const navBackground = _ => {
        if(window.scrollY >= 30) {
            setActived(true)
        } else {
            setActived(false)
        }
    }

    window.addEventListener('scroll', navBackground)
    return (
        <Navbar className={actived ? "dashboard-navbar dashboard-active" : "dashboard-navbar" } collapseOnSelect expand="lg" fixed="top">
           <Container fluid className="dashboard-fluid">
            <NavJudul />
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                <div className="search-category-menu-nav">
                    <Input cGroup="dashboard-input" placeholder="Cari barang ..." />
                </div>
                <Nav className="me-auto">
                      <NavIcons />
                      <CardsNav />
                      <HeadCard />
                </Nav>
             </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}
